import React from "react";
import { gtmData1 } from "./data";
import "../assests/CSS/GTMcomponent1.css";

const GTMcomponent1 = () => {
  return (
    <div className="gtm1-container">
      <p className="gtm1-top-p">{gtmData1.topText}</p>
      <h3 className="gtm1-top-h3">{gtmData1.title}</h3>
      <h3 className="gtm1-top-h3-2">{gtmData1.title2}</h3>

      {/* SVG Section */}
      <div className="gtm1-svg-wrapper">
        {/* Desktop SVG */}
        <div className="gtm1-svg gtm1-svg-desktop">
          <svg
            viewBox="0 0 1611 334"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path d="M264.093 106.657C267.217 103.533 272.283 103.533 275.407 106.657L411.648 242.898C414.772 246.022 414.772 251.087 411.648 254.211L398.213 267.646C395.088 270.771 390.023 270.771 386.899 267.646L250.658 131.406C247.534 128.281 247.534 123.216 250.658 120.092L264.093 106.657Z" fill="#1B3AB6"/>
            <path d="M277 131C277 135.418 273.418 139 269 139L19 139L19 104L269 104C273.418 104 277 107.582 277 112L277 131Z" fill="#1B3AB6"/>
            <rect x="258" y="116" width="16" height="16" rx="8" fill="white"/>
            <path d="M19 5L385 5C391.075 5 396 9.92487 396 16V53C396 59.0751 391.075 64 385 64L19 64L19 5Z" fill="#001479"/>
            <path d="M378.714 8.30161C383.01 4.00585 389.975 4.00584 394.27 8.30161L669.701 283.732C673.997 288.028 673.997 294.993 669.701 299.289L643.538 325.452C639.242 329.747 632.278 329.747 627.982 325.452L352.551 50.0209C348.255 45.7251 348.255 38.7603 352.551 34.4646L378.714 8.30161Z" fill="#001479"/>
            <rect x="367" y="25" width="24" height="24" rx="12" fill="white"/>
            <path d="M385 243C385 238.582 388.582 235 393 235H1611V270H393C388.582 270 385 266.418 385 262V243Z" fill="#1B3AB6"/>
            <path d="M507 132C507 127.582 510.582 124 515 124H1611V159H515C510.582 159 507 155.418 507 151V132Z" fill="#7997E2"/>
            <path d="M628 278C628 273.582 631.582 270 636 270H1611V329H636C631.582 329 628 325.418 628 321V278Z" fill="#001479"/>
            <path d="M32 159H1611V235H32V159Z" fill="#3E6CE0"/>
            <rect x="311" y="178" width="38" height="38" rx="19" fill="white"/>
            <path d="M333.422 313.133C330.298 310.009 330.298 304.944 333.422 301.82L508.777 126.465C511.902 123.341 516.967 123.341 520.091 126.465L539.183 145.557L358.171 326.568C355.047 329.693 349.982 329.693 346.858 326.568L333.422 313.133Z" fill="#7997E2"/>
            <path d="M0 294H352C356.418 294 360 297.582 360 302V321C360 325.418 356.418 329 352 329H0L0 294Z" fill="#7997E2"/>
            <rect x="145" y="300" width="24" height="24" rx="12" fill="white"/>
          </svg>
        </div>

        {/* Mobile SVG */}
        <div className="gtm1-svg gtm1-svg-mobile">
          <svg
            viewBox="0 0 392 304"
            width="100%"
            height="100%"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path d="M-142.907 76.6569C-139.783 73.5327 -134.717 73.5327 -131.593 76.6569L4.64758 212.898C7.77178 216.022 7.77178 221.087 4.64758 224.211L-8.78744 237.646C-11.9116 240.771 -16.977 240.771 -20.1012 237.646L-156.342 101.406C-159.466 98.2814 -159.466 93.2161 -156.342 90.0919L-142.907 76.6569Z" fill="#1B3AB6"/>
            <path d="M-28.286 -21.6984C-23.9902 -25.9942 -17.0254 -25.9942 -12.7296 -21.6984L262.701 253.732C266.997 258.028 266.997 264.993 262.701 269.289L236.538 295.452C232.242 299.747 225.278 299.747 220.982 295.452L-54.4489 20.0209C-58.7447 15.7251 -58.7447 8.76033 -54.4489 4.46456L-28.286 -21.6984Z" fill="#001479"/>
            <path d="M-22 213C-22 208.582 -18.4183 205 -14 205H1095V240H-14C-18.4183 240 -22 236.418 -22 232V213Z" fill="#1B3AB6"/>
            <path d="M100 102C100 97.5817 103.582 94 108 94H1095V129H108C103.582 129 100 125.418 100 121V102Z" fill="#7997E2"/>
            <path d="M221 248C221 243.582 224.582 240 229 240H1095V299H229C224.582 299 221 295.418 221 291V248Z" fill="#001479"/>
            <path d="M-375 129H1095V205H-375V129Z" fill="#3E6CE0"/>
            <path d="M-73.5775 283.133C-76.7017 280.009 -76.7017 274.944 -73.5775 271.82L101.777 96.4647C104.902 93.3405 109.967 93.3405 113.091 96.4647L132.183 115.557L-48.8288 296.568C-51.953 299.693 -57.0183 299.693 -60.1425 296.568L-73.5775 283.133Z" fill="#7997E2"/>
          </svg>
        </div>
      </div>

      <p className="gtm1-desc">{gtmData1.description}</p>
    </div>
  );
};

export default GTMcomponent1;
